import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summaryDescription: {
		id: 'business-tabs.add-tab-details.summary-description',
		defaultMessage:
			'Get an overview of work progress, priorities, workload distribution, and other projects.',
		description: 'Description of the summary view.',
	},
	boardDescription: {
		id: 'business-tabs.add-tab-details.board-description',
		defaultMessage:
			'Get a snapshot of the status of your team’s work and easily drag your cards through a workflow.',
		description: 'Description of the board view.',
	},
	listDescription: {
		id: 'business-tabs.add-tab-details.list-description',
		defaultMessage: 'Get a list of your project’s work in spreadsheet-like table.',
		description: 'Description of the list view.',
	},
	timelineDescription: {
		id: 'business-tabs.add-tab-details.timeline-description',
		defaultMessage:
			'Plan and manage your project dependencies on a timeline and see when things are landing.',
		description: 'Description of the timeline view.',
	},
	calendarDescription: {
		id: 'business-tabs.add-tab-details.calendar-description',
		defaultMessage:
			'See when work is due and get a quick glance at what the next month looks like.',
		description: 'Description of the calendar view.',
	},
	formsDescription: {
		id: 'business-tabs.add-tab-details.forms-description',
		defaultMessage: 'Collect information for your team with forms.',
		description: 'Description of the forms view.',
	},
	approvalsDescription: {
		id: 'business-tabs.add-tab-details.approvals-description',
		defaultMessage: 'Add approvals into your workflow to save you time following up.',
		description: 'Description of the approvals view.',
	},
	attachmentsDescription: {
		id: 'business-tabs.add-tab-details.attachments-description',
		defaultMessage: 'View attachments that have been added to issues within your project.',
		description: 'Description of the attachments view.',
	},
	pagesDescription: {
		id: 'business-tabs.add-tab-details.pages-description',
		defaultMessage: 'Create and manage Confluence pages in your project.',
		description: 'Description of the pages view.',
	},
	shortcutsDescription: {
		id: 'business-tabs.add-tab-details.shortcuts-description',
		defaultMessage: 'Add easily accessible links for your team to access from your project.',
		description: 'Description of the shortcuts view.',
	},
	issuesDescription: {
		id: 'business-tabs.add-tab-details.issues-description',
		defaultMessage: 'View all the issues in a project.',
		description: 'Description of the issues view.',
	},
	reportsDescription: {
		id: 'business-tabs.add-tab-details.reports-description',
		defaultMessage: 'View statistics for people, projects, versions, or information about issues.',
		description: 'Description of the reports view.',
	},
	componentsDescription: {
		id: 'business-tabs.add-tab-details.components-description',
		defaultMessage: 'Use components to create subsections of a project.',
		description: 'Description of the components view.',
	},
	appDescription: {
		id: 'business-tabs.add-tab-details.app-description',
		defaultMessage: 'Supercharge your project by integrating third-party apps.',
		description: 'Description of the app view.',
	},
	archivedIssuesDescription: {
		id: 'business-tabs.add-tab-details.archived-issues-description',
		defaultMessage: 'View all the issues archived in your project here.',
		description: 'Description of the archived issues view.',
	},
});
